export default "__VITE_ASSET__CGanJ0gK__"